import React, {Component} from 'react';
import 'moment/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';

class EditableCell extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: this.props.name,
            value: "",
            inFocus: false
        }
    }

    clear = () => {
        this.input.value = ''
    }

    render() {
        return (
            <td className={"editable " + this.props.name} style={this.props.disabled === true ? {backgroundColor: "#ccc"} : null}>
                <input
                    disabled={this.props.disabled}
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    onChange={(event) => this.props.handleChange(event)}
                    maxLength={this.props.maxlength}
                    ref={input => this.input = input}
                />
            </td>
        );
    }
}

export default EditableCell


// WEBPACK FOOTER //
// ./src/components/Orders/EditableCell.js